import React from "react";
import { ResponsiveContainer, LineChart, Line } from "recharts";

// Tiny sparkline wrapper around recharts
export function Sparklines({ data, children }) {
  const chartData = (data || []).map((v, i) => ({ i, v }));
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={chartData} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
        {React.Children.map(children, (c) => React.cloneElement(c))}
      </LineChart>
    </ResponsiveContainer>
  );
}

export function SparkLine({ color }) {
  return <Line type="monotone" dataKey="v" stroke={color} strokeWidth={2} dot={false} isAnimationActive />;
}
